export default __webpack_public_path__ + "static/media/about.9ff15f3a.png";